<i18n>
{
	"en": {
		"title": "Images",
		"noImage": "No images available",
		"noImageSelected": "Select an image"
	},
	"no": {
		"title": "Bilder",
		"noImage": "Ingen tilgjengelige bilder",
		"noImageSelected": "Velg et bilde"
	}
}
</i18n>

<template>
	<t-dialog
		icon="media"
		iconType="bp"
		:hasFooter="false"
		:isShown="isShown"
		:title="$t('title')"
		bodyStyle="margin-top: 0px"
		@close="onClose"
	>
		<div style="display: flex; flex: 1; height: 80vh;">
			<t-tab-list :items="tabs" :selected.sync="selectedTab" sidebar/>

			<t-pane
				v-if="tabs && tabs.length > 0"
				background="tint2"
				style="width: 100%; margin-top: 0;"
				center
			>
				<img v-if="selectedTab" :src="selectedTab.url" class="img-size">
				<TNoContentPanel v-else :text="$t('noImageSelected')" class="content-size"/>
			</t-pane>
			<TNoContentPanel v-else :text="$t('noImage')" class="content-size"/>
		</div>
		
	</t-dialog>
</template>

<script>
export default {
	name: 'ImageViewer',
	components: {
	},
	props: {
		isShown: Boolean,
		images: {
			type: Array,
			default: () => ([])
		}
	},
	data() {
		return {
			selectedTab: undefined,
			tabs: [],
		};
	},
	watch: {
		images(newVal) {
			if (newVal) {
				this.setTabs(newVal);
			}
		}
	},
	methods: {
		setTabs(images) {
			this.tabs = images.map((value, index) => ({ url: value, label: `Image ${index+1}` }));
			if (this.tabs.length > 0) {
				this.selectedTab = this.tabs[0];
			}
		},
		onClose() {
			this.$emit('close');
		}
	},

};
</script>

<style lang="scss" scoped>
	.content-size {
		height: 100%;
	}
	.img-size {
		max-width:100%;
		max-height:100%;
	}
</style>
